const dealers = [
  'Auction Joe',
  'California Quake Cars',
  'Carvana',
  'CarSoup',
  'Texas Titan Trucks & Autos',
  'NYC Gridlock Gladiators',
  'Florida Gator Grip Garage',
  'Chicago Boss Buys',
  'Vegas Viper Vehicles',
  'Rocky Mountain Rumble Rides',
  'Miami Mayhem Motors',
  'Arizona Avalanche Autos',
  'Detroit Dominator Deals',
  'Seattle Sasquatch Sales',
  'Philly Phantom Fleet',
  'Austin Armadillo Auto',
  'Dallas Dynasty Drive',
  'Hollywood Heavy Hitters Auto',
  'Georgia Goliath Garage',
  'Boston Barracuda Buys',
  'Houston Honcho Hub',
  'New Orleans Nightmare Negotiations',
  'San Antonio Showdown Sales',
  "Christine's Cars & Classics",
  "Camille's Convertible Collection",
  "Sierra's Speedy Sales",
  "Olivia's Outrageous Offers",
  "Mia's Marvelous Motors",
  "Kyle's Killer Cars",
  "Dylan's Dream Deals",
  "Brian's Bargain Busters",
  "Harsh's Hot Wheels",
  "Spencer's Select Autos",
  "Jake's Jolly Jalopies",
  "Eddie's Elite Autos",
  "Andrew's Amazing Autos",
];

const messages = [
  {
    receiverMessage:
      "Alright [userName], you were viewing that auction and your bid is over! You were already knocking on the door for this. Don't let this one get away. One more time, [userName]?",
    senderMessage: '',
  },
  {
    receiverMessage: "Is that all the horsepower you've got in your offer?",
    senderMessage: '',
  },
  {
    receiverMessage: "Don't let this ride drive away without you!",
    senderMessage: '',
  },
  {
    receiverMessage: "Feeling like you're in the slow lane of bidding?",
    senderMessage: '',
  },
  {
    receiverMessage: 'Time to rev up your offer!',
    senderMessage: '',
  },
  {
    receiverMessage: "This beauty's a keeper, don't let it pass you by!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Someone's looking for a steal... are you going to let them take it?",
    senderMessage: '',
  },
  {
    receiverMessage: "Don't be stuck in neutral, place your bid!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Don't let [dealerName] take the lead! It's time to rev up your offer!",
    senderMessage: '[dealerName] takes the lead with their latest bid!',
  },
  {
    receiverMessage: "This ride's about to stall if you don't act fast!",
    senderMessage: '',
  },
  {
    receiverMessage: 'Are you just going to watch from the rearview mirror?',
    senderMessage: '',
  },
  {
    receiverMessage: "The engine's warming up, time to make your move!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Ouch! Looks like someone else wants those keys too. You've got to act fast!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Uh oh, swiped! Don't let them drive off into the sunset without a fight. Your turn!",
    senderMessage: '',
  },
  {
    receiverMessage:
      'Outbid! Are you really going to let [dealerName] have the last word (and the car)!?',
    senderMessage: '[dealerName] is getting the last word in this auction!',
  },
  {
    receiverMessage:
      "Don't tap out now! Show them you mean business. [dealerName] won't get away that easily!",
    senderMessage: "[dealerName] showing the competition who's boss!",
  },
  {
    receiverMessage:
      '[dealerName] just raised the stakes! Feeling lucky? Or feeling like winning? Bid again!',
    senderMessage: '[dealerName] just raised the stakes!',
  },
  {
    receiverMessage: "Don't let [dealerName] drive away for that price!",
    senderMessage: '[dealerName] is driving away with the car!',
  },
  {
    receiverMessage:
      'Looks like [dealerName] is trying to play hardball. Are you going to let them win?',
    senderMessage: '[dealerName] is playing hardball!',
  },
  {
    receiverMessage: 'Someone else thinks they want it more. Prove them wrong!',
    senderMessage: '',
  },
  {
    receiverMessage:
      'Oof! Outbid. Are you going to let them get away with that?',
    senderMessage: '',
  },
  {
    receiverMessage:
      'Alert! Your claim to vehicular awesomeness is being challenged. Re-engage!',
    senderMessage: '',
  },
  {
    receiverMessage: "Looks like you've got some serious competition.",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Aw, did someone else just snag YOUR dream ride? Don't be a spectator!",
    senderMessage: '',
  },
  {
    receiverMessage:
      'Oh dear, looks like your bid went for a little nap. Time to wake it up!',
    senderMessage: '',
  },
  {
    receiverMessage:
      "Looks like someone else is trying to steal your thunder. Time to show them who's boss!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Don't let your bid become a distant memory. One click could change everything!",
    senderMessage: '',
  },
  {
    receiverMessage: "Don't get sniped! Fight back!",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Heads up! Your bid's been topped. This beauty is getting away!",
    senderMessage: '',
  },
  {
    receiverMessage: "\"Psst... they think they've won. Prove 'em wrong?",
    senderMessage: '',
  },
  {
    receiverMessage:
      "Well, that didn't last long! Someone else just showed you how it's done. Your move?",
    senderMessage: '',
  },
  {
    receiverMessage:
      '[dealerName] is having you rethink your life choices for this vehicle. Bid again!',
    senderMessage:
      'Congratulations, [dealerName]! Your bid is currently making other bidders question their life choices. Well played!',
  },
  {
    receiverMessage:
      '[dealerName] wishes you good luck with that. Do you think you can win?',
    senderMessage:
      '[dealerName] is in pole position! To everyone else: better luck next time... or the time after that...',
  },
  {
    receiverMessage:
      '[dealerName] is leaving you with your jaw on the floor. Can you handle it?',
    senderMessage:
      '[dealerName] just dropped the mic with that bid! Other bidders, you might want to pick up your jaws from the floor.',
  },
  {
    receiverMessage:
      "[dealerName] is taking this vehicle out of the driveway and into the winner's circle. Can you keep up?",
    senderMessage:
      "[dealerName], your bid is currently the envy of the auction. For others, it's the sound of an empty driveway.",
  },
  {
    receiverMessage: '[dealerName] is making it look easy. Can you keep up?',
    senderMessage:
      '[dealerName] just made that bid look like a walk in the park! Other bidders, you might want to take notes.',
  },
  {
    receiverMessage:
      "[dealerName] is showing you how it's done. Can you keep up?",
    senderMessage:
      '[dealerName] just raised the bar! Other bidders, time to step up your game.',
  },
  {
    receiverMessage:
      '[dealerName] is waving goodbye to the competition. Can you keep up?',
    senderMessage:
      "[dealerName]! You're cruising towards victory. Other bidders, feel free to wave as they pass you by.",
  },
];

export { messages, dealers };
